import React from "react";
import { Heading, Text, Box, Image, Flex } from "rebass";
import styled from "styled-components";
import Img from "react-image";

import Circle from "../../components/ui/Circle";
import Button from "../../components/ui/Button";
import analyticsIcons from "../../img/analytics-icon.svg";
import analyticsBg from "../../img/analytics-bg.jpg";
import analyticsMiniChart from "../../img/analytics-mini-chart.jpg";

type Props = {
  siteMetadata: { appUrl: string }
};

const IntroPart4 = (props: Props) => (
  <StyledFlex w={[1]}>
    <ContentBox
      ml={["auto", null, 0]}
      w={[1]}
      mb={[4, 4, 6]}
      pl={[0, 0, 0, "120px"]}
      className="relative"
    >
      <LargeCircles>
        <LargeCircle1 r={221.5} />
        <LargeCircle2 r={221.5} />
      </LargeCircles>

      <AnalyticsIcons src={analyticsIcons} alt="Analytics icon" is={Img} />

      <Heading
        color="support2"
        className="font-light text-right text-left-desktop"
        is="h4"
        f={[3, 4, "26px"]}
        mb={[3]}
      >
        Perfect for sales, marketing, and business owners
      </Heading>
      <Text
        color="support1"
        f="15px"
        className="text-right text-left-desktop"
        mb={[4]}
        w={[1, 1, 1, 1 / 2, "35%"]}
      >
        Pipeline has been built from the ground up with analytics to help you
        track your marketing spend.
      </Text>
      <div className="text-right text-left-desktop">
        <Button is="a" href={props.siteMetadata.appUrl}>
          GET STARTED FOR FREE
        </Button>
      </div>
    </ContentBox>

    <AnalyticsBg src={analyticsBg} alt="user chart diagram" is={Img} />

    <AnalyticsMiniChart
      src={analyticsMiniChart}
      alt="analytics mini chart"
      is={Img}
    />
  </StyledFlex>
);

export default IntroPart4;

// Styled Components
const StyledFlex = styled(Flex)`
  min-height: 570px;
  position: relative;

  @media (min-width: 32em) {
    min-height: 620px;
  }

  @media (min-width: 38em) {
    min-height: 680px;
  }

  @media (min-width: 48em) {
    min-height: 610px;
  }

  @media (min-width: 64em) {
    min-height: 570px;
  }
`;

const ContentBox = styled(Box)`
  z-index: 2;
`;

const AnalyticsIcons = styled(Image)`
  right: -10px;
  margin: 0;
  position: absolute;
  top: -104px;
  transform: scale(0.8);

  @media (min-width: 48em) {
    right: auto;
    left: 0;
    top: -130px;
    transform: scale(1);
  }

  @media (min-width: 64em) {
    left: 120px;
    top: -130px;
  }
`;

const LargeCircles = styled.div`
  display: none;
  opacity: 0.7;

  @media (min-width: 64em) {
    display: block;
    left: 0;
    position: absolute;
    top: -260px;
  }

  @media (min-width: 90em) {
    left: -7%;
  }

  @media (min-width: 100em) {
    left: -20%;
  }

  @media (min-width: 110em) {
    left: -35%;
  }

  @media (min-width: 10em) {
    display: none;
  }
`;

const LargeCircle1 = styled(Circle)`
  left: -425px;
  position: relative;
`;

const LargeCircle2 = styled(Circle)`
  left: -425px;
  position: absolute;
  top: 50%;
`;

const AnalyticsBg = styled(Image)`
  position: absolute;
  right: 0;
  top: 160px;
  width: 842px;
  z-index: 1;

  @media (min-width: 32em) {
    top: 110px;
  }

  @media (min-width: 48em) {
    top: -70px;
  }

  @media (min-width: 56em) {
    top: -130px;
  }

  @media (min-width: 64em) {
    top: -170px;
  }
`;

const AnalyticsMiniChart = styled(Image)`
  bottom: 50px;
  position: absolute;
  right: 26%;
  width: 186px;
  z-index: 0;

  @media (min-width: 48em) {
    bottom: 80px;
  }
`;



// WEBPACK FOOTER //
// ./src/components/Intro/IntroPart4.jsx